import 'typeface-audiowide';
import 'typeface-prata';
import 'typeface-spectral';
import React from "react";
import { Link, graphql } from "gatsby";

import Bio from "../components/bio";
import Layout from "../components/layout";
import TagSection from '../components/tagSection';
import SEO from "../components/seo";
import { rhythm } from "../utils/typography";
import './index.css';

const BlogIndex = (props) => {
  const { data, location } = props;
  const siteTitle = data.site.siteMetadata.title;
  const posts = data.allMarkdownRemark.edges;

  return (
    <Layout location={props.location} title={siteTitle}>
      <SEO title="All posts" />
      <Bio location={location} />
      {posts.map(({ node }) => {
        const title = node.frontmatter.title || node.fields.slug
        if (node.frontmatter.published) {
          return (
            <article key={node.fields.slug}>
              <header>
                <h3
                  style={{
                    marginBottom: rhythm(1 / 4),
                  }}
                >
                  <Link style={{ boxShadow: `none` }} to={node.fields.slug}>
                    {title}
                  </Link>
                </h3>
                <small>{node.frontmatter.date}</small>
              </header>
              <section>
                <p
                  dangerouslySetInnerHTML={{
                    __html: node.frontmatter.description || node.excerpt,
                  }}
                />
              </section>
              <TagSection maxTags={3} node={node} />
            </article>
          )
        } else {
          return null
        }
      })}
    </Layout>
  )
};

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            tags
            published
          }
        }
      }
    }
  }
`
